<template>
  <div class="annotations-wrapper">

    <!-- Modal para agregar anotación -->
    <modal
      name="addAnnotation"
      style="z-index: 100000001"
      :height="'auto'"
      :width="430"
      :adaptive="true"
      classes="annotation-vue-modal"
      @before-close="onAddModalClosed"
    >
      <div class="annotation-dialog">
        <div class="annotation-dialog-header">
          <h2>Agregar anotación</h2>
        </div>

        <div class="annotation-dialog-body">
          <div class="annotation-form-group">
            <label for="annotation-text">
              Texto
            </label>

            <textarea
              id="annotation-text"
              v-model="annotationData.text"
              maxlength="100"
              placeholder="Escribe el contenido de la anotación"
            ></textarea>

            <span class="annotation-character-count">
              {{ annotationTextLength }} / 100
            </span>
          </div>

          <AnnotationStyleEditor v-model="annotationData.style" />

          <label class="annotation-checkbox-option" for="share">
            <input
              id="share"
              v-model="annotationData.is_shared"
              type="checkbox"
            >

            <span>Compartir con grupos</span>
          </label>

          <AnnotationGroupSelector
            v-if="annotationData.is_shared"
            v-model="annotationData.id_groups"
            :groups="myGroups"
          />
        </div>

        <div class="annotation-dialog-actions">
          <button
            type="button"
            class="annotation-dialog-btn annotation-dialog-btn--secondary"
            @click="hideModal()"
          >
            Cancelar
          </button>

          <button
            type="button"
            class="annotation-dialog-btn annotation-dialog-btn--primary"
            :disabled="isSavingAnnotation"
            @click="onClickOk()"
          >
            {{ isSavingAnnotation ? 'Guardando…' : 'Confirmar' }}
          </button>
        </div>
      </div>
    </modal>
    <!-- Información de una anotación seleccionada -->
    <AnnotationInfo
      :info="annotationInfo"
      :groups="myGroups"
      @saveEdit="editAnnotationsLayers()"
    />

    <!-- Panel flotante -->
    <div
      v-show="isActive"
      id="annotationsID"
      class="map-tool-window annotations-tool-window"
    >
      <div
        id="annotationsIDheader"
        class="map-tool-window-header"
      >
        <p class="map-tool-window-header-title">
          Anotaciones
        </p>

        <div class="map-tool-window-header-actions">

          <button
            type="button"
            class="control-btn"
            @click="isHidden = !isHidden"
          >
            <svg
              v-if="isHidden"
              viewBox="0 0 24 24"
            >
              <line x1="12" y1="5" x2="12" y2="19" />
              <line x1="5" y1="12" x2="19" y2="12" />
            </svg>

            <svg
              v-else
              viewBox="0 0 24 24"
            >
              <line x1="5" y1="12" x2="19" y2="12" />
            </svg>
          </button>

          <button
            type="button"
            class="control-btn"
            @click="exitAnnotations()"
          >
            <svg viewBox="0 0 24 24">
              <line x1="5" y1="5" x2="19" y2="19" />
              <line x1="19" y1="5" x2="5" y2="19" />
            </svg>
          </button>

        </div>
      </div>

      <div
        v-show="!isHidden"
        class="map-tool-window-body annotations-tool-body"
      >
        <p class="annotations-description">
          Selecciona las anotaciones que deseas visualizar en el mapa.
        </p>

        <div class="annotation-options">

          <!-- Mis anotaciones -->
          <div class="annotation-option">
            <input
              id="showAnnotations1"
              v-model="showUserAnnotations"
              class="annotation-checkbox"
              type="checkbox"
            >

            <label for="showAnnotations1">
              <span>Mis anotaciones</span>

              <span
                class="annotation-dot annotation-dot--user"
                aria-hidden="true"
              ></span>
            </label>
          </div>

          <!-- Anotaciones del grupo -->
          <div class="annotation-option">
            <input
              id="showAnnotations2"
              v-model="showGroupAnnotations"
              class="annotation-checkbox"
              type="checkbox"
            >

            <label for="showAnnotations2">
              <span>Anotaciones del grupo</span>

              <span
                class="annotation-dot annotation-dot--group"
                aria-hidden="true"
              ></span>
            </label>
          </div>

        </div>

        <div class="annotations-actions">
          <div
            v-if="isAddingAnnotation"
            class="annotation-placement-status"
            role="status"
          >
            <span class="annotation-placement-status-icon" aria-hidden="true">+</span>
            <span>
              <strong>Modo de anotación activo</strong>
              Haz clic en el mapa para ubicar el punto.
            </span>
          </div>

          <button
            type="button"
            class="annotations-add-btn"
            :class="{ 'annotations-add-btn--active': isAddingAnnotation }"
            :aria-pressed="isAddingAnnotation ? 'true' : 'false'"
            @click="toggleAnnotationMode()"
          >
            <span aria-hidden="true">{{ isAddingAnnotation ? '×' : '+' }}</span>
            {{ isAddingAnnotation ? 'Cancelar ubicación' : 'Agregar anotación' }}
          </button>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import { draggableDiv } from '@/components/mixin/draggableDiv.js'
import { vuex } from '@/components/mixin/vuex.js'
import AnnotationInfo from '@/components/mapTools/annotations/AnnotationInfo.vue'
import { annotations } from './annotations.js'
import { mapService } from '@/services/map/mapService.js'
import AnnotationStyleEditor from './AnnotationStyleEditor.vue'
import AnnotationGroupSelector from './AnnotationGroupSelector.vue'
import {
  cloneAnnotationStyle,
  DEFAULT_USER_ANNOTATION_STYLE
} from './annotationStyles.js'

export default {
  name: 'annotations',
  mixins: [vuex, draggableDiv, annotations],
  props: ['isFixed', 'currentMode'],
  components: {
    AnnotationInfo,
    AnnotationStyleEditor,
    AnnotationGroupSelector
  },
  data() {
    return {
      map: null,
      isHidden: false,
      annotationData: {
        "id_user": "",
        "id_map": "",
        "id_groups": [],
        "text": "",
        "location": {
          "type": "Point",
          "coordinates": [0, 0]
        },
        "is_shared": false,
        "style": cloneAnnotationStyle(DEFAULT_USER_ANNOTATION_STYLE)
      },
      myself: null,
      myGroups: [],
      showUserAnnotations: false,
      showGroupAnnotations: false,
      annotationInfo: "",
      isAddingAnnotation: false,
      isSavingAnnotation: false,
      userAnnotationsRequestId: 0,
      groupAnnotationsRequestId: 0
    }
  },
  methods: {
    exitAnnotations: function () {
      this.cleanupAnnotations()
      this.selectMapTool('annotations', false)
    },
    cleanupAnnotations: function () {
      this.userAnnotationsRequestId += 1
      this.groupAnnotationsRequestId += 1
      this.isAddingAnnotation = false
      if (!this.map) return
      this.removeAnnotationInteraction()
      this.removeAnnotationSelectorListener()
      this.removeAnnotationsByUserLayer()
      this.removeAnnotationsByGroupLayer()
    },
    toggleAnnotationMode: function () {
      if (this.isAddingAnnotation) {
        this.stopAnnotationMode()
        return
      }
      if (!this.myself) {
        this.$store.dispatch('toast/show', {
          message: 'Espera un momento mientras se carga la información de usuario.',
          type: 'info'
        })
        return
      }
      this.isAddingAnnotation = true
      this.addAnnotationInteraction()
    },
    stopAnnotationMode: function () {
      this.isAddingAnnotation = false
      if (this.map) this.removeAnnotationInteraction()
    },
    openAnnotationModal: function (coordinates) {
      if (!this.myself) return
      this.stopAnnotationMode()
      this.cleanAnnotationData()
      this.annotationData.id_user = this.myself.id
      this.annotationData.id_map = this.$route.params.idMap
      this.annotationData.location.coordinates = coordinates
      this.$modal.show('addAnnotation')
    },
    openAnnotationInfo: function (info) {
      this.annotationInfo = Object.assign({}, info)
    },
    hideModal: function () {
      this.$modal.hide('addAnnotation')
    },
    onAddModalClosed: function () {
      this.isSavingAnnotation = false
      this.stopAnnotationMode()
    },
    onClickOk: async function () {
      const text = this.annotationData.text.trim()
      if (!text) {
        this.$store.dispatch('toast/show', {
          message: 'Escribe un texto para la anotación.',
          type: 'warning'
        })
        return
      }
      if (this.annotationData.is_shared && !this.annotationData.id_groups.length) {
        this.$store.dispatch('toast/show', {
          message: 'Selecciona al menos un grupo para compartir la anotación.',
          type: 'warning'
        })
        return
      }

      this.annotationData.text = text
      this.isSavingAnnotation = true
      try {
        await this.insertAnnotation()
        const annotationsWereVisible = this.showUserAnnotations
        this.showUserAnnotations = true
        if (annotationsWereVisible) this.getAnnotationsByUser(this.myself.id)
        this.$modal.hide('addAnnotation')
        this.$store.dispatch('toast/show', {
          message: 'Anotación agregada y visible en el mapa.',
          type: 'success'
        })
      } catch (error) {
        console.error(error)
        this.$store.dispatch('toast/show', {
          message: 'No fue posible guardar la anotación.',
          type: 'error'
        })
      } finally {
        this.isSavingAnnotation = false
      }
    },
    getMyself: function () {
      const that = this;
      this.$http.get(this.$store.getters.backendurl + 'api/v1/accounts/me')
        .then(function (response) {
          that.myself = response.data;
          that.getMyGroups();
          if (that.isActive && that.showUserAnnotations) {
            that.getAnnotationsByUser(that.myself.id)
          }
          if (that.isActive && that.showGroupAnnotations) {
            that.getAnnotationsByGroup()
          }
        })
        .catch(function (error) {
          console.log(error)
        });
    },
    getMyGroups: function () {
      const that = this;
      const backendurl = this.$store.getters.backendurl;
      this.$http.get(backendurl + 'api/v1/annotations/current/groups')
        .then(function (response) {
          that.myGroups = Array.isArray(response.data) ? response.data : [];
        })
        .catch(function (error) {
          console.error(error)
          that.myGroups = []
          that.$store.dispatch('toast/show', {
            message: 'No fue posible cargar los grupos disponibles.',
            type: 'error'
          })
        });
    },
    insertAnnotation: function () {
      return this.$http.post(
        this.$store.getters.backendurl + 'api/v1/annotations',
        this.annotationData
      )
    },
    cleanAnnotationData() {
      this.annotationData.text = ""
      this.annotationData.is_shared = false
      this.annotationData.id_groups = []
      this.annotationData.style = cloneAnnotationStyle(DEFAULT_USER_ANNOTATION_STYLE)
    },
    getAnnotationsByUser: function (userId) {
      const requestId = ++this.userAnnotationsRequestId
      const that = this
      if (!userId || !this.showUserAnnotations || !this.isActive) return Promise.resolve();
      return this.$http.get(this.$store.getters.backendurl + 'api/v1/annotations/' + userId)
        .then(function (response) {
          if (
            requestId === that.userAnnotationsRequestId &&
            that.showUserAnnotations &&
            that.isActive
          ) {
            that.getFeaturesByUser(response.data || [])
          }
        })
        .catch(function (error) {
          if (requestId !== that.userAnnotationsRequestId) return
          console.error(error)
          that.$store.dispatch('toast/show', {
            message: 'No fue posible cargar tus anotaciones.',
            type: 'error'
          })
        })
    },
    getAnnotationsByGroup: function () {
      const requestId = ++this.groupAnnotationsRequestId
      const that = this
      if (!this.myself || !this.myself.id_groups || !this.myself.id_groups.length || !this.showGroupAnnotations || !this.isActive) {
        return Promise.resolve()
      }
      return this.$http.get(this.$store.getters.backendurl + 'api/v1/annotations/current/group')
        .then(function (response) {
          if (
            requestId === that.groupAnnotationsRequestId &&
            that.showGroupAnnotations &&
            that.isActive
          ) {
            that.getFeaturesByGroup(response.data || [], that.myself.id)
          }
        })
        .catch(function (error) {
          if (requestId !== that.groupAnnotationsRequestId) return
          console.error(error)
          that.$store.dispatch('toast/show', {
            message: 'No fue posible cargar las anotaciones del grupo.',
            type: 'error'
          })
        })
    },
    editAnnotationsLayers: function () {
      if (!this.myself) return
      if (this.showUserAnnotations) this.getAnnotationsByUser(this.myself.id)
      if (this.showGroupAnnotations) this.getAnnotationsByGroup()
    }
  },
  computed: {
    annotationTextLength: function () {
      return Array.from(this.annotationData.text || '').length
    },
    isActive: function () {
      // return this.isFixed? this.isMobile : this.mapToolValues('annotations').active && !this.isMobile
      return this.mapToolValues('annotations').active
    }
  },
  watch: {
    'annotationData.is_shared': function (value) {
      if (!value) this.annotationData.id_groups = []
    },
    'mapToolExecuted': function () {
      const action = this.mapToolValues('annotations').action;
      const data = this.mapToolValues('annotations').data;

      if (action == 'showModal') {
        this.openAnnotationModal(data.annotationCoor)
      }
      else if (action == 'showAnnotationInfo') {
        this.openAnnotationInfo(data.info)
      }
      else if (action == 'addListener') {
        this.isAddingAnnotation = true
        this.addAnnotationInteraction()
      }
      else if (action == 'removeListener') {
        this.isAddingAnnotation = false
        this.removeAnnotationInteraction()
      }
      else if (action == 'addAnnotationSelector') {
        this.addAnnotationSelectorListener()
      }
      else if (action == 'removeAnnotationSelector') {
        this.removeAnnotationSelectorListener()
      }
      else if (action == 'showAnnotationsByUser') {
        this.getFeaturesByUser(data.annotationsByUser)
      }
      else if (action == 'showAnnotationsByGroup') {
        this.getFeaturesByGroup(data.annotationsByGroup, data.userId)
      }
      else if (action == 'removeAnnotationsByUser') {
        if (this.removeAnnotationsByUserLayer) this.removeAnnotationsByUserLayer()
      }
      else if (action == 'removeAnnotationsByGroup') {
        if (this.removeAnnotationsByGroupLayer) this.removeAnnotationsByGroupLayer()
      }
    },
    'isActive': function (value) {
      if (value) {
        if (this.myself && this.showUserAnnotations) this.getAnnotationsByUser(this.myself.id)
        if (this.myself && this.showGroupAnnotations) this.getAnnotationsByGroup()
        if (this.map) this.addAnnotationSelectorListener()
      } else {
        this.cleanupAnnotations()
      }
    },
    'mapInteractionTool': function (tool) {
      if (!this.map || !this.isActive) return
      if (tool === 'annotations') {
        if (this.isAddingAnnotation) this.addAnnotationInteraction()
        else this.addAnnotationSelectorListener()
        return
      }
      // removeAnnotationInteraction() vuelve a colgar el selector
      // (annotations.js:161-164), por eso se quita después.
      this.removeAnnotationInteraction()
      this.removeAnnotationSelectorListener()
    },
    'showUserAnnotations': function (value) {
      if (value) {
        if (this.myself) this.getAnnotationsByUser(this.myself.id)
      }
      else {
        this.userAnnotationsRequestId += 1
        this.removeAnnotationsByUserLayer()
      }
      if (this.showGroupAnnotations) {
        this.removeAnnotationsByGroupLayer()
        this.getAnnotationsByGroup()
      }
    },
    'showGroupAnnotations': function (value) {
      if (value) {
        if (this.myself) this.getAnnotationsByGroup()
      }
      else {
        this.groupAnnotationsRequestId += 1
        this.removeAnnotationsByGroupLayer()
      }
    }
  },
  created: function () {
    this.getMyself()
  },
  mounted: function () {
    this.makeDraggable("annotationsID");
    this.map = mapService.get();
    if (this.isActive) {
      if (this.myself && this.showUserAnnotations) this.getAnnotationsByUser(this.myself.id)
      if (this.myself && this.showGroupAnnotations) this.getAnnotationsByGroup()
      this.addAnnotationSelectorListener()
    }
  },
  beforeDestroy: function () {
    this.cleanupAnnotations();
  }
}
</script>
<style scoped lang="scss">
.annotations-tool-window {
  top: 4em;
  right: 16px;
  width: 340px;
  max-width: calc(100vw - 32px);
  z-index: 1000;
}

.annotations-tool-body {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.annotations-description {
  margin: 0;
  color: var(--color-ghost);
  font-size: 0.8rem;
  line-height: 1.45;
}

.annotation-options {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.annotation-option {
  display: flex;
  align-items: center;
  gap: 10px;

  min-height: 42px;
  padding: 8px 10px;

  background: var(--color-white);
  border: 1px solid var(--color-line);
  border-radius: 4px;

  transition:
    background-color 0.2s ease,
    border-color 0.2s ease;

  &:hover {
    background: var(--color-mist);
    border-color: var(--color-steel);
  }

  label {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;

    flex: 1;
    margin: 0;

    color: var(--color-graphite);
    font-size: 0.85rem;
    font-weight: 600;
    cursor: pointer;
  }
}

.annotation-checkbox {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  margin: 0;

  accent-color: var(--color-orange);
  cursor: pointer;
}

.annotation-dot {
  flex-shrink: 0;
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.annotation-dot--user {
  background: var(--color-steel);
}

.annotation-dot--group {
  background: var(--color-orange);
}

.annotations-actions {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-end;
  gap: 10px;

  padding-top: 12px;
  border-top: 1px solid var(--color-line);
}

.annotation-placement-status {
  display: flex;
  align-items: center;
  gap: 10px;

  padding: 10px;

  background: rgba(242, 140, 40, 0.12);
  border: 1px solid var(--color-orange);
  border-radius: 4px;

  color: var(--color-graphite);
  font-size: 0.78rem;
  line-height: 1.35;

  strong {
    display: block;
    color: var(--color-navy);
  }
}

.annotation-placement-status-icon {
  display: grid;
  flex: 0 0 26px;
  width: 26px;
  height: 26px;
  place-items: center;

  background: var(--color-orange);
  border-radius: 50%;

  color: var(--color-white);
  font-size: 1.2rem;
  font-weight: 700;
}

.annotations-add-btn {
  align-self: flex-end;

  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;

  min-height: 36px;
  padding: 8px 14px;

  background: var(--color-navy);
  border: 1px solid var(--color-navy);
  border-radius: 4px;

  color: var(--color-white);
  font-family: inherit;
  font-size: 0.82rem;
  font-weight: 600;

  cursor: pointer;

  transition:
    background-color 0.2s ease,
    border-color 0.2s ease;

  &:hover {
    background: var(--color-steel);
    border-color: var(--color-steel);
  }

  &:focus-visible {
    outline: 2px solid var(--color-steel);
    outline-offset: 2px;
  }

  span {
    font-size: 1.1rem;
    font-weight: 700;
    line-height: 1;
  }
}

.annotations-add-btn--active {
  background: var(--color-orange);
  border-color: var(--color-orange);

  &:hover {
    background: var(--color-white);
    border-color: var(--color-orange);
    color: var(--color-orange);
  }
}
</style>
